(() => {
  document.addEventListener('cart-update', (event) => {
    const count = Number(event.detail?.item_count);
    if (!Number.isInteger(count)) return;
    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      const label = bubble.querySelector('.visually-hidden');
      if (label) label.textContent = `${count} ${count === 1 ? window.cartStrings.item : window.cartStrings.items}`;
    });
  });
})();
